import { NotificationCenter } from '@mgdis/notification-center';

export const defineNotificationCenter = () => {
  Object.defineProperty(window, 'NotificationCenter', { value: new NotificationCenter() });
};
